/**
 * Created by f on 2019/4/4.
 */

import batchImport from '../components/batchImport';
import Vue from 'vue';
import { log } from 'util';
declare module 'vue/types/vue' {
    interface Vue {
        batchImport: any;
        succeed: any;
        err: any;
        popError: any;
        showUpdated: any;
        gettingStarted: any;
        gettingStartedId: any;
        validateErrors: any;
        EventBus: any;
    }
}
const plugins = {
    install: function(vue: any) {
        Vue.prototype.gettingStartedId = '';
        Vue.prototype.batchImport = (options: any) => {
            let prioptions = options;
            let instance: any;
            if (!instance) {
                const LoadingPlugin = Vue.extend(batchImport);
                instance = new LoadingPlugin({
                    el: document.createElement('div'),
                });
                document.body.appendChild(instance.$el);
            }
            instance.show = false;
            instance.options ? (instance.options = instance.options) : (instance.options = {});
            Object.assign(instance.options, prioptions);
            return new Promise((resolve, reject) => {
                instance.show = true;
                let successBtn = instance.successBtn;
                let cancelBtn = instance.cancelBtn;
                instance.successBtn = () => {
                    successBtn();
                    resolve('ok');
                };
                instance.cancelBtn = () => {
                    cancelBtn();
                    reject();
                };
            });
        };
        Vue.prototype.succeed = (msg: string) => {
            let instance: any;
            if (!instance) {
                let el = document.createElement('div');
                el.setAttribute('class', 'succeed-up-wins autu-pop-up-win');
                let elHhtml: any = `<div class="modification"><div class="m-auto br-ra4 bg-secgreen500 title">${msg}</div></div>`;
                el.innerHTML = elHhtml;
                document.body.appendChild(el);
                setTimeout(() => {
                    let node = document.querySelector('.succeed-up-wins');
                    if (node && node.parentNode) {
                        node.parentNode.removeChild(node);
                    }
                }, 1000);
            }
        };
        Vue.prototype.err = (msg: string) => {
            let instance: any;
            if (!instance) {
                let el = document.createElement('div');
                el.setAttribute('class', 'error-up-wins autu-pop-up-win');
                let elHhtml: any = `<div class="modification wid-100 bg-red200 "><div class="d-flex wid100 align-items-center"><div class="m-auto br-ra4 title-err ft-red900 col" style="text-align: center">${msg}</div><div class="icon-30 f-18 ft-red900 cursor-p" onclick="hideError()" style="margin-right: 35px; width: 30px;"></div></div></div>`;
                el.innerHTML = elHhtml;
                let node = document.getElementById('riehgRouterView');
                if (node && node.parentNode) {
                    node.appendChild(el);
                }
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.setAttribute('class', 'error-up-js');
                script.appendChild(
                    document.createTextNode(
                        'function hideError(){let node = document.querySelector(".error-up-wins");if (node && node.parentNode) {node.parentNode.removeChild(node);};let nodejs = document.querySelector(".error-up-js"); if (nodejs && nodejs.parentNode) { nodejs.parentNode.removeChild(nodejs); }}'
                    )
                );
                document.body.appendChild(script);
                document.getElementsByTagName('body')[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start',
                });
                setTimeout(() => {
                    let node = document.querySelector('.error-up-wins');
                    if (node && node.parentNode) {
                        node.parentNode.removeChild(node);
                    }
                }, 3000);
            }
        };
        Vue.prototype.popError = (options: any) => {
            let instance: any;
            if (!instance) {
                if (options.isRemove) {
                    let node = document.querySelector('.error-up-wins');
                    if (node && node.parentNode) {
                        node.parentNode.removeChild(node);
                    }
                    return;
                }
                let el = document.createElement('div');
                el.setAttribute('class', 'p-3 br-ra4 wid-100 bg-red100 bg-errorHint error-up-wins');
                el.setAttribute(
                    'style',
                    'position: fixed; margin: auto; z-index: 99999999; top: 0px;  left: 30%; boootm: 0;  width: 40%; justify-content: center;color: #D32F2F !important;'
                );
                let elHhtml: any = `
 <h2 class="ft-error">${options.title ? options.title : ''}</h2>
                <div  class="d-flex " style="justify-content: center;"> ${
                    options.text ? options.text : options
                }</div>
 `;
                el.innerHTML = elHhtml;
                let node = document.getElementById('riehgRouterView');
                if (node && node.parentNode) {
                    node.appendChild(el);
                }
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.setAttribute('class', 'error-up-js');
                script.appendChild(
                    document.createTextNode(
                        'function hideError(){let node = document.querySelector(".error-up-wins");if (node && node.parentNode) {node.parentNode.removeChild(node);};let nodejs = document.querySelector(".error-up-js"); if (nodejs && nodejs.parentNode) { nodejs.parentNode.removeChild(nodejs); }}'
                    )
                );
                document.body.appendChild(script);
                if (options.isAutoRemove) {
                    setTimeout(() => {
                        let node = document.querySelector('.error-up-wins');
                        if (node && node.parentNode) {
                            node.parentNode.removeChild(node);
                        }
                    }, 3000);
                }
            }
        };
        Vue.prototype.showUpdated = (msg: any) => {
            let instance: any;
            if (!instance) {
                let el = document.createElement('div');
                el.setAttribute('class', 'updated-up-wins autu-pop-up-win');
                let elHhtml: any = `<div style="position: fixed; top:35px; right: 15px;"><div class="unis-modal-select d-flex  flex-column align-items-start" style="width: 504px;"><div class="d-flex p-4 justify-content-between wid100"><h2>${
                    msg.title
                }</h2><i class="f-24 icon-30 cursor-p" onclick="hideUpdated()"></i></div><div class="d-flex wid-100 mb-4"><div class="col pl-4 align-self-stretch content">${
                    msg.mag
                }</div></div></div></div>`;
                el.innerHTML = elHhtml;
                document.body.appendChild(el);
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.setAttribute('class', 'updated-up-js');
                script.appendChild(
                    document.createTextNode(
                        'function hideUpdated(){let node = document.querySelector(".updated-up-wins");if (node && node.parentNode) {node.parentNode.removeChild(node);};let nodejs = document.querySelector(".updated-up-js"); if (nodejs && nodejs.parentNode) { nodejs.parentNode.removeChild(nodejs); }}'
                    )
                );
                document.body.appendChild(script);
                setTimeout(() => {
                    let node = document.querySelector('.updated-up-wins');
                    if (node && node.parentNode) {
                        node.parentNode.removeChild(node);
                    }
                    let nodejs = document.querySelector('.updated-up-js');
                    if (nodejs && nodejs.parentNode) {
                        nodejs.parentNode.removeChild(nodejs);
                    }
                }, 3000);
            }
        };
        Vue.prototype.gettingStarted = (msg: any) => {
            let node = document.getElementById('getting-started-with');
            if (node && node.parentNode) {
                node.parentNode.removeChild(node);
            }
            let idstog: any | null = document.getElementById(msg['id']);
            let el = document.createElement('div');
            el.setAttribute('class', msg['class']);
            el.setAttribute('id', 'getting-started-with');
            let elHhtml: any = msg['html'];
            el.innerHTML = elHhtml;
            idstog.appendChild(el);
        };
        Vue.prototype.validateErrors = (_this: any) => {
            let validateErrors = _this.errors.items;
            if (validateErrors.length > 0) {
                document.getElementsByName(validateErrors[0]['field'])[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center',
                });
            }
        };
        Vue.prototype.EventBus = {
            globalEvent: function(eventName: any, params: any) {},
        };
    },
};

export default plugins;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/shared/popups.ts